<template>
  <div>
    <h1>Thanks</h1>
    <div style="width: 300px; height: 300px; background-color: green"></div>
  </div>
</template>

<script>
export default {
  name: "ThankYou",
};
</script>

<style lang="sass" scoped>
</style>